// project js
require('./3rd_party/bootstrap');
require('./3rd_party/modernizr');
require('./3rd_party/utils');

require('./fixedNav');
require('./tinySlider');
require('./input');
require('./scroll');
require('./switch');
require('./tooltips');
require('./pricingLookupTable');
require('./locale');
require('./numScroller');
require('./pricingComparisonStickyHeader');
require('./tileRevealMeetTheTeam');
require('./homepageSlider');
require('./jquery.transit.js');
require('./contentItemsFilter');
require('./academy');
require('./navigationCarousel');
require('./homePageHeroAnimation');

require('jquery-validation');


$(function() {
    SiteControl.init();
});


var SiteControl = {
    init: function() {

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        this.initFileUpload();
        this.validateForms();
    },

    initFileUpload: function () {
        var $wrapper = $('.js-file-upload');

        // We can attach the `fileselect` event to all file inputs on the page
        $(document).on('change', ':file', function () {
            var input = $(this),
                numFiles = input.get(0).files ? input.get(0).files.length : 1,
                label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
            input.trigger('fileselect', [numFiles, label]);
        });

        // We can watch for our custom `fileselect` event like this
        $wrapper.find(':file').on('fileselect', function (event, numFiles, label) {
            var input = $(this).parents('.input-group').find(':text'),
                log = numFiles > 1 ? numFiles + ' files selected' : label;
            if (input.length) {
                input.val(log);
            }
        });
    },

    validateForms: function () {
        var $forms = $('.js-validate-form');

        if (!$forms.length) {
            return true;
        }

        $forms.each(function (i, el) {
            var $form = $(el);

            $form.validate({
                submitHandler: function (form) {
                    buttonSpinner($form.find('button[type="submit"]'), true);

                    $(window).on('unload', function () {
                        buttonSpinner($form.find('button[type="submit"]'), false);
                    });

                    form.submit();
                },
                onfocusout: function (element) {
                    if ($form.data('validation-submit-only')) {
                        return false;
                    }

                    $(element).valid();
                },
                highlight: function (element) {
                    $(element).parents('.form-group').removeClass('has-success').addClass('has-error');
                },
                unhighlight: function (element) {
                    $(element).parents('.form-group').removeClass('has-error');//.addClass('has-success');
                },
                errorPlacement: function (error, element) {
                    $(element).closest('.form-group').append(error);
                },
                errorElement: 'span',
                errorClass: 'help-block'
            })
        });
    }
};